const HeroCTA = ({ onLearnMore }) => (
  <div className="hero-cta-group">
    <button onClick={onLearnMore} className="btn-secondary btn-large">
      En Savoir Plus
    </button>
  </div>
);

export default HeroCTA;
